import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import NotificationsContext from 'providers/Notifications/Notifications.context';
import InfiniteScroll from 'components/InfiniteScroll';
import ReportsEmptyState from 'router/subrouters/DataRoom/subrouters/Reports/pages/Reports/components/ReportsEmptyState';
import NotificationsHeader from 'components/NotificationsHeader';
import useNotifications from '../../../hooks/useNotifications';
import useLeadNotifications from '../../../hooks/useLeadNotifications';
import { getIsNotificationForLeads } from 'utils';
import LeadNotificationsContext from 'providers/LeadNotifications/LeadNotifications.context';
import NotificationsForLeadsFilters from 'components/NotificationsForLeadsFilters';

import './Notifications.styles.scss';

type NotificationsProps = {
  className?: string;
};

const Notifications: React.FC<NotificationsProps> = (props) => {
  const { className } = props;

  const { notificationBy, onNotificationsScroll } =
    useContext(NotificationsContext);
  const { onNotificationsScroll: onLeadNotificationsScroll } = useContext(
    LeadNotificationsContext,
  );

  const { showEmptyState, placeholders, renderedCards } = useNotifications();

  const {
    showEmptyState: leadShowEmptyState,
    placeholders: leadPlaceholders,
    renderedCards: leadRenderedCards,
  } = useLeadNotifications();

  const isForLeads = getIsNotificationForLeads(notificationBy);

  const shouldShowEmptyState = useMemo(
    () => (isForLeads && leadShowEmptyState) || (!isForLeads && showEmptyState),
    [isForLeads, leadShowEmptyState, showEmptyState],
  );

  const classes = classNames('notifications', className);

  return (
    <div className={classes}>
      <NotificationsHeader />

      <NotificationsForLeadsFilters />

      <InfiniteScroll
        className="notifications__content"
        onScroll={
          isForLeads ? onLeadNotificationsScroll : onNotificationsScroll
        }
      >
        {shouldShowEmptyState && <ReportsEmptyState />}

        {isForLeads ? leadRenderedCards : renderedCards}

        {isForLeads ? leadPlaceholders : placeholders}
      </InfiniteScroll>
    </div>
  );
};

export default Notifications;
